import initialState from 'initial-state'
import models from 'careers/models'

export default {

  ...initialState,

  careers: {

    jobs: [],

    isFetching: false,

    unpublished: false,

    company: {
      name: '',
      slug: '',
      logo: '',
      photo: '',
      jobAds: [],
    },

  },

  ...models,

}
